(ns teamoesterreich.user-mode.neighbor.neighbor
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    ))






(defn get-it []
  (let [!actual-user (r/cursor store/app-state [:actual-user])
        ]
    ;(a/set-bottom-action-fn #(a/set-page-back ))
    [mui/grid
     {:container  true
      :direction  "column"
      :justify    "center"
      :alignItems "center"
      :spacing    4
      :style      {:marginTop "10px"}
      }
     [mui/grid
      {:container false
       :item      true
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"}}
       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "space-between"
         :alignItems "flex-start"
         :spacing    2
         }
        [mui/grid
         {:container false
          :item      true
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h1
          (txt/txt :neighbor "Nachbarschaftshilfe-Titel")]
         [:p
          (txt/txt :neighbor "Nachbarschaftshilfe-Text1")]
         [:p
          (txt/txt :neighbor "Nachbarschaftshilfe-Text2")]
         ]


        ;; buttons

        [mui/grid
         {:container false
          :item      true
          :xs        12                                     ;extra-small: 0px
          :style     {:textAlign "center" :padding "30px 0 30px 0"}
          }
         [mui/grid
          {:container  true
           :direction  "row"
           :justify    "space-between"
           :alignItems "flex-start"
           :spacing    2
           }
          [mui/grid
           {:container false
            :item      true
            :md        5                                    ;medium: 960px
            :xs        12
            }
           [:a
            {:target "_blank"
             :href   (txt/txt :neighbor "BraucheHilfeLink")
             :style  {:textDecoration "none"}}
            [mui/button
             {:variant "contained"
              :color   "primary"
              :style   {:width "300px"}
              }
             "\"Ich brauche Hilfe\""]]
           ]

          [mui/grid
           {:container false
            :item      true
            :md        5                                    ;medium: 960px
            :xs        12
            :style     {}
            }
           [mui/button
            {:variant "contained"
             :color   "secondary"
             :style   {:width "300px"}
             :onClick (fn []
                        (if (:tom-id @!actual-user)
                          (a/set-page :wanaHelp)
                          (a/open-login)))
             }
            "\"Ich will helfen\""]
           ]
          ]]]



       [mui/grid
        {:container false
         :item      true
         :md        5                                       ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         :style     {:padding "15px"}
         }
        [mui/button
         {:variant   "contained"
          :style     {:margin "10px 0 10px 10px" :width "200px"}
          :onClick   #(a/set-page-back)
          :startIcon (r/as-element [keyboard-arrow-left])
          }
         "Zurück"]]

       ]]]
    ))


